export function LimitMeta({ goal, styles }) {
  const hasStats =
    typeof goal.successCount === 'number' && typeof goal.failCount === 'number';

  return (
    <div className={styles.goalMeta}>
      {goal.limitInfoText ? <p className={styles.goalMeta__line}>{goal.limitInfoText}</p> : null}
      {goal.periodInfoText ? <p className={styles.goalMeta__line}>{goal.periodInfoText}</p> : null}

      {hasStats ? (
        <div className={styles.goalMeta__stats}>
          <div className={styles.goalMeta__stat}>
            <span className={styles.goalMeta__label}>Достигнуто</span>
            <span className={`${styles.goalMeta__value} ${styles['goalMeta__value--success']}`}>
              {goal.successCount}
            </span>
          </div>

          <span className={styles.goalMeta__slash}>/</span>

          <div className={styles.goalMeta__stat}>
            <span className={styles.goalMeta__label}>Не достигнуто</span>
            <span className={`${styles.goalMeta__value} ${styles['goalMeta__value--fail']}`}>
              {goal.failCount}
            </span>
          </div>
        </div>
      ) : null}
    </div>
  );
}